var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAndorra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47831 28.5116C10.4503 29.4652 12.6627 30 15 30C17.3374 30 19.5497 29.4652 21.5217 28.5116L22.8261 15L21.5217 1.4884C19.5497 0.534844 17.3374 0 15 0C12.6627 0 10.4503 0.534844 8.47831 1.4884L7.17395 15L8.47831 28.5116Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5217 28.5114C26.5391 26.0853 29.9999 20.9472 29.9999 15.0003C29.9999 9.05348 26.5391 3.91539 21.5217 1.48926V28.5114Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47828 28.5114V1.48926C3.46084 3.91539 0 9.05342 0 15.0003C0 20.9472 3.46084 26.0853 8.47828 28.5114Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.2174C15 17.8237 15 15 15 15H18.9131V16.9565C18.9131 17.2964 18.2609 18.5419 16.6512 19.5652C16.0415 19.9529 15.4104 20.0776 15 20.2174Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 11.087H11.087V15H15.0001V11.087Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9565 9.78312C16.9565 9.06271 16.3725 8.47876 15.6522 8.47876C15.4143 8.47876 15.192 8.54345 15 8.65466C14.808 8.54345 14.5858 8.47876 14.3479 8.47876C13.6275 8.47876 13.0435 9.06271 13.0435 9.78312H9.78265V16.3048C9.78265 18.7327 11.7107 20.1368 13.2228 20.8646C13.1096 21.0578 13.0435 21.2821 13.0435 21.5223C13.0435 22.2427 13.6275 22.8266 14.3479 22.8266C14.5858 22.8266 14.8081 22.7619 15 22.6507C15.192 22.7619 15.4143 22.8266 15.6522 22.8266C16.3725 22.8266 16.9565 22.2427 16.9565 21.5223C16.9565 21.2821 16.8904 21.0578 16.7772 20.8646C18.2892 20.1368 20.2174 18.7327 20.2174 16.3048V9.78312H16.9565ZM18.2609 16.3048C18.2609 16.6447 18.2609 17.6789 16.6512 18.7023C16.0415 19.09 15.4104 19.3413 15 19.4811C14.5896 19.3413 13.9586 19.09 13.3488 18.7023C11.7392 17.6789 11.7392 16.6447 11.7392 16.3048V11.7396H18.2609V16.3048Z",
    fill: "#FF9811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAndorra);
export default __webpack_public_path__ + "static/media/icon-andorra.72c1ecf6daea18ba1b9d5699ba16881d.svg";
export { ForwardRef as ReactComponent };